/* eslint-disable */
import dynamic from 'next/dynamic';


import GoogleTagManagerNoscript from '@magalu/mixer-modules/build/esm/novisual/GoogleTagManagerNoscript';
import AdsBanner from '@magalu/mixer-modules/build/esm/components/ecommerce/AdsBanner';
import ExternalContent from '@magalu/mixer-modules/build/esm/components/ecommerce/ExternalContent';
import HeaderDesktop from '@magalu/mixer-modules/build/esm/components/ecommerce/HeaderDesktop';
import Breadcrumb from '@magalu/mixer-modules/build/esm/components/ecommerce/Breadcrumb';
import Heading from '@magalu/mixer-modules/build/esm/components/ecommerce/Heading';
import SearchFilters from '@magalu/mixer-modules/build/esm/components/ecommerce/SearchFilters';
import LinkList from '@magalu/mixer-modules/build/esm/components/ecommerce/LinkList';
import SeoRelatedLinkList from '@magalu/mixer-modules/build/esm/components/ecommerce/SeoRelatedLinkList';
import Row from '@magalu/mixer-modules/build/esm/components/ecommerce/Row';
import AdsBrand from '@magalu/mixer-modules/build/esm/components/ecommerce/AdsBrand';
import SearchHeader from '@magalu/mixer-modules/build/esm/components/ecommerce/SearchHeader';
import SearchOrder from '@magalu/mixer-modules/build/esm/components/ecommerce/SearchOrder';
import ProductList from '@magalu/mixer-modules/build/esm/components/ecommerce/ProductList';
import Pagination from '@magalu/mixer-modules/build/esm/components/ecommerce/Pagination';
import Faq from '@magalu/mixer-modules/build/esm/components/ecommerce/Faq';
import SeoCategoryTreeLinks from '@magalu/mixer-modules/build/esm/components/ecommerce/SeoCategoryTreeLinks';
import LuContent from '@magalu/mixer-modules/build/esm/components/ecommerce/LuContent';
import DocumentSupportText from '@magalu/mixer-modules/build/esm/components/ecommerce/DocumentSupportText';
import SeoLinkList from '@magalu/mixer-modules/build/esm/components/ecommerce/SeoLinkList';
import FooterDesktop from '@magalu/mixer-modules/build/esm/components/ecommerce/FooterDesktop';
import Ebit from '@magalu/mixer-modules/build/esm/novisual/Ebit';
import ReclameAqui from '@magalu/mixer-modules/build/esm/novisual/ReclameAqui';
import Favicon from '@magalu/mixer-modules/build/esm/novisual/Favicon';
import Preconnect from '@magalu/mixer-modules/build/esm/novisual/Preconnect';
import Datadog from '@magalu/mixer-modules/build/esm/novisual/Datadog';
import GoogleTagManagerHead from '@magalu/mixer-modules/build/esm/novisual/GoogleTagManagerHead';
import Stewie from '@magalu/mixer-modules/build/esm/novisual/Stewie';
import AllIn from '@magalu/mixer-modules/build/esm/novisual/AllIn';
import Criteo from '@magalu/mixer-modules/build/esm/novisual/Criteo';
import TikTok from '@magalu/mixer-modules/build/esm/novisual/TikTok';
import SpotifyAdAnalytics from '@magalu/mixer-modules/build/esm/novisual/SpotifyAdAnalytics';
import RTBHouse from '@magalu/mixer-modules/build/esm/novisual/RTBHouse';
import Vwo from '@magalu/mixer-modules/build/esm/novisual/Vwo';
import Azion from '@magalu/mixer-modules/build/esm/novisual/Azion';
import Bing from '@magalu/mixer-modules/build/esm/novisual/Bing';

const pageModules = {
  GoogleTagManagerNoscript,
  AdsBanner,
  ExternalContent,
  HeaderDesktop,
  Breadcrumb,
  Heading,
  SearchFilters,
  LinkList,
  SeoRelatedLinkList,
  Row,
  AdsBrand,
  SearchHeader,
  SearchOrder,
  ProductList,
  Pagination,
  Faq,
  SeoCategoryTreeLinks,
  LuContent,
  DocumentSupportText,
  SeoLinkList,
  FooterDesktop,
  Ebit,
  ReclameAqui,
  Favicon,
  Preconnect,
  Datadog,
  GoogleTagManagerHead,
  Stewie,
  AllIn,
  Criteo,
  TikTok,
  SpotifyAdAnalytics,
  RTBHouse,
  Vwo,
  Azion,
  Bing,
  ZipCodeInput: dynamic(() => import('@magalu/mixer-modules/build/esm/components/ecommerce/ZipCodeInput'),
    { ssr: false }
  ),
  SelectedFilters: dynamic(() => import('@magalu/mixer-modules/build/esm/components/ecommerce/SelectedFilters'),
    { ssr: false }
  ),
  CardanForm: dynamic(() => import('@magalu/mixer-modules/build/esm/components/ecommerce/CardanForm'),
    { ssr: false }
  ),
  AdsCarousel: dynamic(() => import('@magalu/mixer-modules/build/esm/components/ecommerce/AdsCarousel'),
    { ssr: false }
  ),
  Loader: dynamic(() => import('@magalu/mixer-modules/build/esm/components/ecommerce/Loader'),
    { ssr: false }
  ),
};

export default pageModules;
